import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DROPDOWN_DATASOURCE_FILTERTYPES } from '../../../../constants/proj.cnst';
import { WidgetPropertyFormService } from '../../widget-property-form.service';
import { firstValueFrom } from 'rxjs';
import { APP_BUILDER_PERMISSIONS, PERMISSIONS_ACTIONS } from 'shared-library';

@Component({
  selector: 'lib-widget-data-filters',
  templateUrl: './widget-data-filters.component.html',
  styleUrl: './widget-data-filters.component.scss'
})
export class WidgetDataFiltersComponent implements OnInit{

  @Input() group!:FormGroup;
  @Input() entities!:any;
  @Input() filterControlName!:any;
  @Input() applicationId!: string;
  @Input() listOfWidgetsOfEntity!: any;
  @Input() filterValues!:any;


  entitiesWidgetsMaping:any = {};
  entitiesWidgetsMappingObj:any = {}

  dropdownDataSourceFilterTypes = DROPDOWN_DATASOURCE_FILTERTYPES;
  dropdownDataSourceFiltersMenu = [this.dropdownDataSourceFilterTypes.manual,this.dropdownDataSourceFilterTypes.widget];

  appPermissions = APP_BUILDER_PERMISSIONS;
  permissionsActions = PERMISSIONS_ACTIONS;

  constructor(private _formBuilder:FormBuilder,private wformService:WidgetPropertyFormService){
    
  }

  ngOnInit(): void {
    this.filterValues.forEach(async (filter:any) => {
      if(filter.filterType === this.dropdownDataSourceFilterTypes.widget){
            await this.setEntityWidgetsMapping(filter['basedEntitys'] ?? [])
            let formGroup = this._formBuilder.group({
              filterType: ['widget',Validators.required],
              basedEntitys:[filter.basedEntitys,],
              basedWidgetIds:this._formBuilder.array([])
            })
            let basedWidgetIdsArray:FormArray = formGroup.get('basedWidgetIds') as FormArray;
            this.patchDropDownDataSourceEntityMappings(filter['basedEntitys'],basedWidgetIdsArray,filter['basedWidgetIds'])
            filter["basedWidgetIds"].forEach((obj:any,index:number) => {    
              this.addItemsInbasedWidgetControlMappingArray({value:obj["basedWidgets"]},index,basedWidgetIdsArray.at(index) ,obj['basedWidgetControlMapping'])
            })
            this.filters.push(formGroup);
            this.dropdownDataSourceFiltersMenu = [this.dropdownDataSourceFilterTypes.manual]
          }else if(filter.filterType === this.dropdownDataSourceFilterTypes.manual){
              this.filters.push(
                this._formBuilder.group({
                  filterType: 'manual',
                  ref: filter.ref,
                  dependentValue: filter.dependentValue,
                })
              );
  
          }
    })
  }

  get filters(){
    return this.group.get(this.filterControlName) as FormArray;
  }
  

   addDataSourceFilter(item:any,index:number){
          if(item === this.dropdownDataSourceFilterTypes.manual){
            let formGroup:FormGroup =  this._formBuilder.group({
              filterType:[this.dropdownDataSourceFilterTypes.manual],
              dependentValue:['',Validators.required],
              ref:['',Validators.required]
            })
            this.filters.push(formGroup);
          
          }else if(item === this.dropdownDataSourceFilterTypes.widget){
            this.filters.push( this._formBuilder.group({
                filterType:[this.dropdownDataSourceFilterTypes.widget,],
                basedEntitys:[[],Validators.required],
                basedWidgetIds:this._formBuilder.array([])
            }))
            this.dropdownDataSourceFiltersMenu.splice(index,1)
          }
        }
  
        patchDropDownDataSourceEntityMappings(entityIds:any,array:FormArray,mappings?:any){
  
          let currentMappings:any = [];
          let tempMappings = {}
          if(mappings){
            currentMappings = mappings.map((entitymapping:any) => entitymapping.entityId); 
            tempMappings = structuredClone(mappings)
          }else{
            currentMappings = array.getRawValue().map((entitymapping:any) => entitymapping.entityId);
            tempMappings = structuredClone(array.getRawValue());
          }
      
          if(mappings && entityIds){
            array.clear();
            entityIds.forEach((entityId:string) => {
                array.push(this.createEntityWidgetFormGroup(entityId,this.getSeletedBasedWidgets(entityId,tempMappings),this.getSeletedBasedWidgetsItemsMapping(entityId,tempMappings)))
            })
          }else if(entityIds){
            entityIds.forEach((entityId:string) => {
                if(!currentMappings.includes(entityId)){
                  array.push(this.createEntityWidgetFormGroup(entityId,this.getSeletedBasedWidgets(entityId,tempMappings),[]))
                }
              })
      
              currentMappings = array.getRawValue().map((entitymapping:any) => entitymapping.entityId);
            if(entityIds.length !== array.length){
              currentMappings.forEach((entityId:any) => {
                if(!entityIds.includes(entityId)){
                  this.removeEntityById(entityId,array);
                }
              })
            }
      
          }
      
        }
  
        getSeletedBasedWidgetsItemsMapping(entityId:string,mappings:any){
          const mapping = mappings.find((entitywidgetMapping:any) => entitywidgetMapping.entityId === entityId);
          return mapping?.basedWidgetControlMapping ?? [];
        }
  
        getSeletedBasedWidgets(entityId:string,mappings:any){
          const mapping = mappings.find((entitywidgetMapping:any) => entitywidgetMapping.entityId === entityId);
          return mapping?.basedWidgets ?? [];
        }

        getEntityRelatedWidgets(entitywidgetMapping:any,entityIndex:any) : any{
          return this.entitiesWidgetsMaping[entitywidgetMapping.value.entityId] ?? [];
        }
      
        removeEntityById(entityId: string,array:FormArray) {
          const formArray = array;
          const index = formArray.controls.findIndex(
            (control) => control.value.entityId === entityId
          );
        
          if (index !== -1) {
            formArray.removeAt(index);
          }
        }
  
        getSelectedEntityName(entitywidgetMapping:any){
          let entity = this.entities.find((entity:any) => entity.entity_id === entitywidgetMapping.value.entityId);
          if(entity){
            return entity.entity_name;
          }else{
            return "";
          }
        }
        
      
        createEntityWidgetFormGroup(entityId: string, basedWidgets: any,basedWidgetControlMapping:any): FormGroup {
          let tempGroup = new FormGroup({
            entityId: new FormControl(""),
            basedWidgets: new FormControl([]),
            basedWidgetControlMapping:this._formBuilder.array([])
          });
      
          tempGroup.patchValue({entityId:entityId,basedWidgets:basedWidgets,basedWidgetControlMapping:basedWidgetControlMapping});
          return tempGroup;
        }

        async fetchAndPatchBasedWntityWidget(event:any,filter:any){
          let entityIds = event.value;
          await this.setEntityWidgetsMapping(entityIds);
          this.patchDropDownDataSourceEntityMappings(entityIds,filter.get('basedWidgetIds') as FormArray);
        }

        async setEntityWidgetsMapping(entities:any){
             let entitysAndRelatedWidgets: any = this.entitiesWidgetsMaping;
              if(entities){
                for (const entity of entities) {
                  const entityId = entity;
                  if (!this.entitiesWidgetsMaping[entityId]) {
                    let response : any = await firstValueFrom(this.wformService.fetchEntity(entityId,this.applicationId))
                    entitysAndRelatedWidgets[entityId] = this.wformService.retriveWidgetsListFromEntiywithConfig(response.data?.page_widget_details);
                  }
                }
              }
        
              this.entitiesWidgetsMaping = entitysAndRelatedWidgets;
              this.entitiesWidgetsMappingObj = this.transformObject(this.entitiesWidgetsMaping);
          }
  
          transformObject(input:any) {
            const output:any = {};
            for (const key in input) {
              if (Array.isArray(input[key])) {
                output[key.toLowerCase()] = input[key].reduce((acc:any, item:any) => {
                  if (item.widgetId) {
                    acc[item.widgetId] = item;
                  }
                  return acc;
                }, {});
              } else {
                output[key.toLowerCase()] = input[key];
              }
            }
            return output;
          }
          

          addItemsInbasedWidgetControlMappingArray(event:any,index:number,filtergroup:any,mappings?:any){
            let widgets = event.value;
            let currentMappings:any = [];
            let tempMappings = {}
            let array : FormArray = filtergroup.get("basedWidgetControlMapping") as FormArray
            if(array){
        
              if(mappings){
                currentMappings = mappings.map((mapping:any) => mapping.widgetId); 
                tempMappings = structuredClone(mappings)
              }else{
                currentMappings = array.getRawValue().map((mapping:any) => mapping.widgetId);
                tempMappings = structuredClone(array.getRawValue());
              }
          
              if(mappings){
                mappings.forEach((mapping:any) => {
                    array.push(new FormGroup({
                      widgetId:new FormControl(mapping.widgetId),
                      dependentValue:new FormControl(mapping.dependentValue,Validators.required)
                    }))
                })
              }else  if(widgets){
                widgets.forEach((widgetId:any) => {
                      if(!currentMappings.includes(widgetId)){
                        array.push(new FormGroup({
                          widgetId:new FormControl(widgetId),
                          dependentValue:new FormControl('',Validators.required)
                        }))
                      }
                    })
        
                currentMappings = array.getRawValue().map((mapping:any) => mapping.widgetId);
                if(widgets.length !== array.length){
                  currentMappings.forEach((widgetId:any) => {
                    if(!widgets.includes(widgetId)){
                      const index = array.controls.findIndex((control) => control.value.widgetId === widgetId);
                      if (index !== -1) {
                        array.removeAt(index);
                      }
                    }
                  })
                }
            }
        
            }
          }

          removeDataSourceFilter(index:number,filter:any){
            if(filter.filterType === this.dropdownDataSourceFilterTypes.widget){
              this.dropdownDataSourceFiltersMenu.push(this.dropdownDataSourceFilterTypes.widget)
            }
            this.filters.removeAt(index);
          }

}
